module.exports = __webpack_public_path__ + "static/media/5_l_shlaem_18.33_85.b1f2362c.png";